import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteMGA } from "../../../../../actions/Utilities/MGA";

const useDeleteMGA = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteMGA(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetMGAList"]);
      toast.fire("Success", "MGA has been deactivated successfully", "success");
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate MGA",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteMGA;
